import {apiWithToken} from '../../systems/api';
import {API_URL} from './../../systems/globalContant';

export default {
    fetchViolateReasons: filter => apiWithToken.get(API_URL.FETCH_VIOLATE_REASONS, {params: filter}),
    createViolateReasons: data => apiWithToken.post(API_URL.FETCH_SLOW_PURCHASING_REASONS, data, {loading: false}),
    updateViolateReasonPriority: data => apiWithToken.put(API_URL.FETCH_SLOW_PURCHASING_REASONS+"/priority", {reasons: data}, {loading: false}),
    updateViolateReasonTitle: data => apiWithToken.put(API_URL.FETCH_SLOW_PURCHASING_REASONS+"/"+data.id, data, {loading: false})
};